import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB4-V2-U1-P9-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page9/E1/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column 1
        { url: 'img/FriendsPlus/Page9/E1/1.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page9/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page9/E1/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page9/E1/4.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page9/E1/5.jpg', },
      ],
      [
        // Column 3
        { url: 'img/FriendsPlus/Page9/E1/6.jpg' },
      ],
      [
        // Column 4
        { url: 'img/FriendsPlus/Page9/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page9/E1/8.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page9/E1/9.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page9/E1/10.jpg' },
      ],
      [
        // Column 5
        { url: 'img/FriendsPlus/Page9/E1/11.jpg' },
      ],
      [
        // Column 6
        { url: 'img/FriendsPlus/Page9/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page9/E1/13.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page9/E1/14.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page9/E1/15.jpg' },
      ],
      [
        // Column 7
        { url: 'img/FriendsPlus/Page9/E1/16.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB4-V2-U1-P9-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page9/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page9/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page9/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page9/E2/3.jpg', input: true, answer: "There are" },
        { url: 'img/FriendsPlus/Page9/E2/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page9/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page9/E2/6.jpg', input: true, answer: "There are" },
        { url: 'img/FriendsPlus/Page9/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page9/E2/8.jpg', input: true, answer: "There are" },
        { url: 'img/FriendsPlus/Page9/E2/9.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page9/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page9/E2/11.jpg', input: true, answer: "There's" },
        { url: 'img/FriendsPlus/Page9/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page9/E2/13.jpg', input: true, answer: "There's" },
        { url: 'img/FriendsPlus/Page9/E2/14.jpg' },
      ],
    ]
  },

}

export default json;